import { createAction } from "redux-actions";
import { SET_LANGUAGE } from "../../constants/index";
import { apiGet } from "../../api/index";
import { urlGetLoginItemTemp } from "../../api/urls";

/**
 * Set TimeZone.
 */
export const setLanguage = createAction(SET_LANGUAGE, (data) => data);

/**
 * Get item.
 */
export const getLoginItem = createAction("GET_ITEM", (token) =>
  apiGet(urlGetLoginItemTemp, [token], false)()
);
